import {SPACE_TYPE_GROUP, SPACE_TYPE_ONE_ON_ONE} from '@webex/react-component-utils';

/**
 * Finds the participant in a direct space that isn't current user
 *
 * @param {object} space
 * @param {string} currentUserId
 * @returns {object} participant object
 */
export function getToParticipant(space, currentUserId) {
  return space.participants.find((p) => p.id !== currentUserId);
}

/**
 * Gets the avatar for a space
 * Will fetch the user avatar for 1:1 spaces
 *
 * @export
 * @param {Object} space
 * @param {Object} props
 * @param {function} props.fetchAvatar redux action
 * @param {object} props.sparkInstance spark sdk instance
 * @param {object} props.users users redux store
 */
export function getSpaceAvatar(space, props) {
  const {users, sparkInstance} = props;

  if (!space.isDecrypting) {
    if (
      space.type === SPACE_TYPE_ONE_ON_ONE
    ) {
      // Find the participant that is not the current user
      const toParticipant = getToParticipant(space, users.get('currentUserId'));

      if (toParticipant) {
        // Direct spaces use the "other participant" as the space avatar
        props.fetchAvatar({userId: toParticipant.id}, sparkInstance);
      }
    }
    else if (
      space.type === SPACE_TYPE_GROUP && space.id
    ) {
      props.fetchAvatar({space}, sparkInstance);
    }
  }
}
